import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text, Platform } from "react-native";
import PercentageCircle from "react-native-progress-circle";

import { Tile } from "components";

import { submitFeedback, tryAgainQuiz } from "state/modules/feedback";

import Layout from "screens/common";

import { styles } from "./styles";

const isNative = Platform.OS !== "web";

class Result extends Component {
  shouldComponentUpdate = () => false;

  render = () => {
    const { score, total } = this.props;
    const percentage = total ? Math.floor((score / total) * 100) : 0;
    const circleColor =
      percentage >= 50
        ? styles._cicleCorrect?.color
        : styles._cicleInorrect?.color;
    const scoreLabel = percentage >= 50 ? "GOOD" : "BAD";

    const Wrapper = isNative ? PercentageCircle : View;

    const wrapperProps = isNative
      ? {
          radius: 100,
          borderWidth: 8,
          color: circleColor,
          percent: percentage,
          bgColor: styles.card?.backgroundColor,
          shadowColor: styles._circle?.backgroundColor,
        }
      : {};
    return (
      <Layout>
        <View style={styles.container}>
          <View style={styles.percentCircleContainer}>
            <Wrapper {...wrapperProps}>
              <Text style={styles.text}>{percentage}%</Text>
              <Text style={[styles.text, styles.scoreLabel]}>{scoreLabel}</Text>
            </Wrapper>
          </View>
          <Tile
            text="DONE"
            style={styles.tiles}
            onPress={() => this.props.submitFeedback(true)}
            textStyle={styles.tilesText}
          />
          <Tile
            text="TRY AGAIN"
            style={styles.tiles}
            onPress={this.props.tryAgainQuiz}
            textStyle={styles.tilesText}
          />
        </View>
      </Layout>
    );
  };
}

const mapDispatchToProps = {
  submitFeedback,
  tryAgainQuiz,
};

const mapStateToProps = state => {
  return {
    score: state.survey.quizScore,
    total: state.survey.quizTotal,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Result);
